export const AUTHENTICATING_USER = 'AUTHENTICATING_USER';
export const LOGGED_USER = 'LOGGED_USER';
export const LOGIN_USER_DETAILS_REQUEST = 'LOGIN_USER_DETAILS_REQUEST';
export const LOGIN_USER_DETAILS_SUCCESS = 'LOGIN_USER_DETAILS_SUCCESS';
export const LOGIN_USER_DETAILS_FAILURE = 'LOGIN_USER_DETAILS_FAILURE';
export const UPDATE_LOGIN_USER_DETAILS_REQUEST = 'UPDATE_LOGIN_USER_DETAILS_REQUEST';
export const UPDATE_LOGIN_USER_DETAILS_SUCCESS = 'UPDATE_LOGIN_USER_DETAILS_SUCCESS';
export const UPDATE_LOGIN_USER_DETAILS_FAILURE = 'UPDATE_LOGIN_USER_DETAILS_FAILURE';
export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const UNAUTHENTICATED_USER = 'UNAUTHENTICATED_USER';
export const TOGGLE_TRIAL_NEWLY_ACTIVATED = 'TOGGLE_TRIAL_NEWLY_ACTIVATED';
export const SET_INVITED_ORGANIZATION = 'SET_INVITED_ORGANIZATION';
export const CLEAR_INVITED_ORGANIZATION = 'CLEAR_INVITED_ORGANIZATION';
export const TRIAL_MODAL_CLOSED = 'TRIAL_MODAL_CLOSED';
export const TRIAL_END_MODAL_CLOSED = 'TRIAL_END_MODAL_CLOSED';
export const FORCE_SETUP_OPEN = 'FORCE_SETUP_OPEN';
export const GET_REPOSITORIES_REQUEST = 'GET_REPOSITORIES_REQUEST';
export const GET_REPOSITORIES_SUCCESS = 'GET_REPOSITORIES_SUCCESS';
export const GET_REPOSITORIES_FAILURE = 'GET_REPOSITORIES_FAILURE';
export const POST_REPOSITORIES_REQUEST = 'POST_REPOSITORIES_REQUEST';
export const POST_REPOSITORIES_SUCCESS = 'POST_REPOSITORIES_SUCCESS';
export const POST_REPOSITORIES_FAILURE = 'POST_REPOSITORIES_FAILURE';
export const GET_BRANCHES_REQUEST = 'GET_BRANCHES_REQUEST';
export const GET_BRANCHES_SUCCESS = 'GET_BRANCHES_SUCCESS';
export const GET_BRANCHES_FAILURE = 'GET_BRANCHES_FAILURE';
export const GET_COMMITS_REQUEST = 'GET_COMMITS_REQUEST';
export const GET_COMMITS_SUCCESS = 'GET_COMMITS_SUCCESS';
export const GET_COMMITS_FAILURE = 'GET_COMMITS_FAILURE';
export const GET_COMMIT_REQUEST = 'GET_COMMIT_REQUEST';
export const GET_COMMIT_SUCCESS = 'GET_COMMIT_SUCCESS';
export const GET_COMMIT_FAILURE = 'GET_COMMIT_FAILURE';
export const GET_COMMIT_COMMON_ISSUES_REQUEST = 'GET_COMMIT_COMMON_ISSUES_REQUEST';
export const GET_COMMIT_COMMON_ISSUES_SUCCESS = 'GET_COMMIT_COMMON_ISSUES_SUCCESS';
export const GET_COMMIT_COMMON_ISSUES_FAILURE = 'GET_COMMIT_COMMON_ISSUES_FAILURE';
export const GET_COMMIT_FILE_ISSUES_REQUEST = 'GET_COMMIT_FILE_ISSUES_REQUEST';
export const GET_COMMIT_FILE_ISSUES_SUCCESS = 'GET_COMMIT_FILE_ISSUES_SUCCESS';
export const GET_COMMIT_FILE_ISSUES_FAILURE = 'GET_COMMIT_FILE_ISSUES_FAILURE';
export const GET_PULL_REQUESTS_REQUEST = 'GET_PULL_REQUESTS_REQUEST';
export const GET_PULL_REQUESTS_SUCCESS = 'GET_PULL_REQUESTS_SUCCESS';
export const GET_PULL_REQUESTS_FAILURE = 'GET_PULL_REQUESTS_FAILURE';
export const GET_PULL_REQUEST_REQUEST = 'GET_PULL_REQUEST_REQUEST';
export const GET_PULL_REQUEST_SUCCESS = 'GET_PULL_REQUEST_SUCCESS';
export const GET_PULL_REQUEST_FAILURE = 'GET_PULL_REQUEST_FAILURE';
export const GET_ORGANIZATIONS_REQUEST = 'GET_ORGANIZATIONS_REQUEST';
export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS';
export const GET_ORGANIZATIONS_FAILURE = 'GET_ORGANIZATIONS_FAILURE';
export const GET_ORGANIZATION_DETAIL_REQUEST = 'GET_ORGANIZATION_DETAIL_REQUEST';
export const GET_ORGANIZATION_DETAIL_SUCCESS = 'GET_ORGANIZATION_DETAIL_SUCCESS';
export const GET_ORGANIZATION_DETAIL_FAILURE = 'GET_ORGANIZATION_DETAIL_FAILURE';
export const ADD_ORGANIZATION_REQUEST = 'ADD_ORGANIZATION_REQUEST';
export const ADD_ORGANIZATION_SUCCESS = 'ADD_ORGANIZATION_SUCCESS';
export const ADD_ORGANIZATION_FAILURE = 'ADD_ORGANIZATION_FAILURE';
export const UPDATE_ORGANIZATION_REQUEST = 'UPDATE_ORGANIZATION_REQUEST';
export const UPDATE_ORGANIZATION_SUCCESS = 'UPDATE_ORGANIZATION_SUCCESS';
export const UPDATE_ORGANIZATION_FAILURE = 'UPDATE_ORGANIZATION_FAILURE';
export const ADD_ORGANIZATION_MEMBER_REQUEST = 'ADD_ORGANIZATION_MEMBER_REQUEST';
export const ADD_ORGANIZATION_MEMBER_SUCCESS = 'ADD_ORGANIZATION_MEMBER_SUCCESS';
export const ADD_ORGANIZATION_MEMBER_FAILURE = 'ADD_ORGANIZATION_MEMBER_FAILURE';
export const REMOVE_ORGANIZATION_MEMBER_REQUEST = 'REMOVE_ORGANIZATION_MEMBER_REQUEST';
export const REMOVE_ORGANIZATION_MEMBER_SUCCESS = 'REMOVE_ORGANIZATION_MEMBER_SUCCESS';
export const REMOVE_ORGANIZATION_MEMBER_FAILURE = 'REMOVE_ORGANIZATION_MEMBER_FAILURE';
export const FINISH_INVITATION_REQUEST = 'FINISH_INVITATION_REQUEST';
export const FINISH_INVITATION_SUCCESS = 'FINISH_INVITATION_SUCCESS';
export const FINISH_INVITATION_FAILURE = 'FINISH_INVITATION_FAILURE';
export const REMOVE_ORGANIZATION_INVITE_REQUEST = 'REMOVE_ORGANIZATION_INVITE_REQUEST';
export const REMOVE_ORGANIZATION_INVITE_SUCCESS = 'REMOVE_ORGANIZATION_INVITE_SUCCESS';
export const REMOVE_ORGANIZATION_INVITE_FAILURE = 'REMOVE_ORGANIZATION_INVITE_FAILURE';
export const GET_BILLING_PLANS_REQUEST = 'GET_BILLING_PLANS_REQUEST';
export const GET_BILLING_PLANS_SUCCESS = 'GET_BILLING_PLANS_SUCCESS';
export const GET_BILLING_PLANS_FAILURE = 'GET_BILLING_PLANS_FAILURE';
export const CHANGE_BILLING_PLAN_REQUEST = 'CHANGE_BILLING_PLAN_REQUEST';
export const CHANGE_BILLING_PLAN_SUCCESS = 'CHANGE_BILLING_PLAN_SUCCESS';
export const CHANGE_BILLING_PLAN_FAILURE = 'CHANGE_BILLING_PLAN_FAILURE';
export const PAY_PLAN_REQUEST = 'PAY_PLAN_REQUEST';
export const PAY_PLAN_SUCCESS = 'PAY_PLAN_SUCCESS';
export const PAY_PLAN_FAILURE = 'PAY_PLAN_FAILURE';
export const ACTIVATE_TRIAL_REQUEST = 'ACTIVATE_TRIAL_REQUEST';
export const ACTIVATE_TRIAL_SUCCESS = 'ACTIVATE_TRIAL_SUCCESS';
export const ACTIVATE_TRIAL_FAILURE = 'ACTIVATE_TRIAL_FAILURE';
export const GET_INVOICES_REQUEST = 'GET_INVOICES_REQUEST';
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_INVOICES_FAILURE = 'GET_INVOICES_FAILURE';
export const CUSTOMER_PORTAL_REQUEST = 'CUSTOMER_PORTAL_REQUEST';
export const CUSTOMER_PORTAL_SUCCESS = 'CUSTOMER_PORTAL_SUCCESS';
export const CUSTOMER_PORTAL_FAILURE = 'CUSTOMER_PORTAL_FAILURE';
export const ADD_UPDATE_REPOSITORY = 'ADD_UPDATE_REPOSITORY';
export const BULK_RELOAD_REPOSITORIES = 'BULK_RELOAD_REPOSITORIES';
export const REMOVE_REPOSITORY = 'REMOVE_REPOSITORY';
export const CLEAR_REPOSITORIES = 'CLEAR_REPOSITORIES';
export const SET_REPOSITORY_SEARCH = 'SET_REPOSITORY_SEARCH';
export const SET_GHA_INSTALLATION = 'SET_GHA_INSTALLATION';
export const ADD_REPOSITORY = 'ADD_REPOSITORY';
export const UPDATE_REPOSITORY = 'UPDATE_REPOSITORY';
export const CLEAR_REPOSITORY = 'CLEAR_REPOSITORY';
export const UPDATE_ACTIVE_BRANCH = 'UPDATE_ACTIVE_BRANCH';
export const CLEAR_ACTIVE_BRANCH = 'CLEAR_ACTIVE_BRANCH';
export const UPDATE_DEFECTS = 'UPDATE_DEFECTS';
export const CLEAR_DEFECTS = 'CLEAR_DEFECTS';
